<template>
  <div class="synthese__container">
    <SyntheseSection
      title="Adhérent"
      :items="proformaDetail"
      class="col-14 col-sm-36"
    />
    <SyntheseSection
      title="Montants"
      :items="montantsDetail"
      class="col-14 col-sm-36"
    />
  </div>
  <FormContainer>
    <template #content>
      <WrapperCheckbox
        id="field_unknown1"
        v-model="attestationSurHonneurModel"
        :alertLabel="meta.attestationSurHonneur?.$messageErreurDirty!"
        :required="meta.attestationSurHonneur?.$status === PropertyStatus.Required"
        label="J’atteste sur l’honneur l’exactitude des données saisies."
        :readonly
        class="col-36"
      />
      <WrapperCheckbox
        id="field_unknown2"
        v-model="acceptationCgModel"
        :required="meta.acceptationCg?.$status === PropertyStatus.Required"
        :alertLabel="meta.acceptationCg?.$messageErreurDirty!"
        :readonly
        class="col-36"
      >
        <BasicText style="flex: 1">
          J'accepte les Conditions Générales (CG) d'Akto et les conditions de prise en charge, et je confirme avoir pris
          connaissance de celles-ci via le lien suivant : «
          <BasicLink
            label="Conditions générales - Akto"
            @link-click="redirectExterne('https://www.akto.fr/conditions-generales')"
          />
        </BasicText>
        »
      </WrapperCheckbox>
      <div class="form__bloc">
        <WrapperInput
          id="field_240"
          v-model="lieuSignatureModel"
          label="Fait à"
          :required="meta.lieuSignature?.$status === PropertyStatus.Required"
          :alert-label="meta.lieuSignature?.$messageErreurDirty"
          class="col-12 col-md-14 col-sm-36"
          deletable
          hint="50 caractères maximum"
          :maxlength="50"
          :readonly
        />
        <WrapperInput
          id="field_unknown"
          v-model="referenceModel"
          label="Référence (propre à votre entreprise)"
          :required="meta.reference?.$status === PropertyStatus.Required"
          :alertLabel="meta.reference?.$messageErreurDirty"
          class="col-24 col-md-22 col-sm-36"
          deletable
          hint="256 caractères maximum"
          :maxlength="256"
          :readonly
        />
      </div>
      <div class="form__bloc">
        <WrapperInput
          id="field_unknown"
          v-model="commentaireModel"
          label="Commentaires (infos complémentaires...)"
          :required="meta.commentaire?.$status === PropertyStatus.Required"
          :alertLabel="meta.commentaire?.$messageErreurDirty"
          class="col-24 col-md-22 col-sm-36"
          deletable
          hint="256 caractères maximum"
          :maxlength="256"
          :readonly
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { DEMANDE_STORE } from '@/features/interface/demande/shared'
  import { computed, inject } from 'vue'
  import { storeToRefs } from 'pinia'
  import { formatNumber } from '@/features/shared/tools'
  import SyntheseSection from '../../../shared/components/SyntheseSection.vue'
  import { PropertyStatus } from '@/features/domaine/property-status'
  import { redirectExterne } from '@/features/shared/tools/url'
  import FormContainer from '../../../shared/components/FormContainer.vue'

  const store = inject(DEMANDE_STORE)!.getStore('MODEL_PROFORMA')
  const { model, meta, readonly } = storeToRefs(store)
  const { setupFieldWithKey } = store

  const lieuSignatureModel = setupFieldWithKey<string>('lieuSignature', true)
  const referenceModel = setupFieldWithKey<string>('reference', true)
  const commentaireModel = setupFieldWithKey<string>('commentaire', true)
  const attestationSurHonneurModel = setupFieldWithKey<boolean>('attestationSurHonneur')
  const acceptationCgModel = setupFieldWithKey<boolean>('acceptationCg')

  const proformaDetail = computed(() => {
    return {
      'Référence proforma groupée': model.value?.reference,
      'Raison sociale / Nom': model.value?.etablissementAdherent.denomination,
      'SIRET': model.value?.etablissementAdherent.siret.valeur
    }
  })

  const montantsDetail = computed(() => {
    return {
      'Total HT': formatNumber(model.value?.remboursements.reduce((sum, module) => sum + (module.montantHt ?? 0), 0), { decimal: 2, separateur: true }) + ' €',
      'Montant TVA': formatNumber(model.value?.remboursements[0]?.montantTva ?? 0, { decimal: 2, separateur: true }) + ' €',
      'Montant facturé': formatNumber(model?.value?.remboursements.reduce((sum, module) => sum + (module.montantHt + module.montantTva), 0), { decimal: 2, separateur: true }) + ' €'
    }
  })
</script>
<style scoped lang="less">
  .synthese__container {
    width: 90%;
    align-self: center;
    margin: @spacing-20 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 20px;

    > div {
      width: calc(50% - 10px);
      border-radius: @border-radius-l;

      @media (max-width: @breakpoint-tablet) {
        width: 100%;
      }
    }

    @container (max-width: @breakpoint-mobile) {
      width: 100%;
    }
  }

  .synthese {
    &__bloc {
      margin: @spacing-20 0;
      display: grid;
      grid-template-columns: repeat(36, 1fr);
      grid-row-gap: @spacing-20;
      grid-column-gap: 2%;
    }
  }

  .element {
    &__header {
      display: flex;
      font-weight: bold;
      padding-bottom: @spacing-10;
      border-bottom: 1px solid @secondary-600;
    }

    &__row {
      flex: 1;
      display: flex;
      padding: 6px 0;
      border-bottom: 1px solid #e0e0e0;
    }

    &__header,
    &__row {
      > span {
        flex: 1;
        padding: 0 @spacing-5;
        text-align: left;
      }
    }
  }
</style>

